module.exports = __webpack_public_path__ + "static/media/PA-Icon-Staubsauger-neg.ccf86a87.svg";